import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { SchoolIncidentTypeInUseRequest } from "./SchoolIncidentTypeInUseRequest";
import { AddSchoolIncidentTypeRequest } from "./AddSchoolIncidentTypeRequest";
import { EditSchoolIncidentTypeRequest } from "./EditSchoolIncidentTypeRequest";

@Injectable()
export class DataService_SchoolIncidentTypeSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadSchoolIncidentType(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadSchoolIncidentType?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolIncidentTypeDescInUse(parms: SchoolIncidentTypeInUseRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/SchoolIncidentTypeDescInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolIncidentTypeCDInUse(parms: SchoolIncidentTypeInUseRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/SchoolIncidentTypeCDInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddType(parms: AddSchoolIncidentTypeRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/AddSchoolIncidentType";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EditType(parms: EditSchoolIncidentTypeRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/EditSchoolIncidentType";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteType(SchoolIncidentTypeID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/DeleteSchoolIncidentType?SchoolIncidentTypeID=" + SchoolIncidentTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ToggleType(SchoolIncidentTypeID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ToggleSchoolIncidentType?SchoolIncidentTypeID=" + SchoolIncidentTypeID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
